import { define } from 'wicked-elements'

define('[data-component~="slider"]', {
  init() {
    this.slider = this.element.querySelector('[data-slider]');
    this.slides = [...this.slider.children];
    this.prevButton = this.element.querySelector('[data-prev]');
    this.nextButton = this.element.querySelector('[data-next]');
    this.pageDots = this.element.querySelectorAll('[data-page-dot]');
    this.currentIndex = 0;

    this.updateCurrentSlide();
    this.updatePageDots();
  },
  connected() {
    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', () => this.slide('prev'));
      this.nextButton.addEventListener('click', () => this.slide('next'));
    }

    this.pageDots.forEach((pageDot, index) => {
      pageDot.addEventListener('click', () => this.goToSlide(index));
    });

    this.slider.addEventListener('scroll', () => this.handleScroll());
  },
  disconnected() {
    if (this.prevButton && this.nextButton) {
      this.prevButton.removeEventListener('click', () => this.slide('prev'));
      this.nextButton.removeEventListener('click', () => this.slide('next'));
    }

    this.pageDots.forEach((pageDot) => {
      pageDot.removeEventListener('click', () => this.goToSlide(index));
    });

    this.slider.removeEventListener('scroll', () => this.handleScroll());
  },
  handleScroll() {
    const { scrollLeft, clientWidth } = this.slider;
    const index = Math.round(scrollLeft / clientWidth);

    if (this.currentIndex !== index) {
      this.currentIndex = index;
      this.updateCurrentSlide();
      this.updatePageDots();
    }
  },
  slide(direction) {
    let left;
    const { scrollLeft, clientWidth } = this.slider;

    switch (direction) {
      case 'prev':
        this.currentIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
        break;
      case 'next':
      default:
        this.currentIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
        break;
    }

    left = this.currentIndex * clientWidth;

    this.slider.scroll({
      left,
      behavior: 'smooth',
    });

    // this.updateCurrentSlide();
    // this.updatePageDots();
  },
  goToSlide(index) {
    const { clientWidth } = this.slider;
    const left = index * clientWidth;

    this.slider.scroll({
      left,
      behavior: 'smooth',
    });

    this.currentIndex = index;
    // this.updateCurrentSlide();
    // this.updatePageDots();
  },
  updateCurrentSlide() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentIndex) {
        slide.classList.add('is-current');
      } else {
        slide.classList.remove('is-current');
      }
    });
  },
  updatePageDots() {
    this.pageDots.forEach((pageDot, index) => {
      if (index === this.currentIndex) {
        pageDot.classList.add('is-current');
      } else {
        pageDot.classList.remove('is-current');
      }
    });
  }
});
